import { render } from "./App.vue?vue&type=template&id=169f499c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=169f499c&lang=css"

import exportComponent from "C:\\Workplace\\WebFrameworks\\vuejs\\egg-picker\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__